/**
 * Scale conversion utilities for device controls.
 * Converts between UI percentages (0-100) and backend byte values (0-255).
 */

/**
 * Clamp a number between min and max values.
 */
export function clampNumber(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/**
 * Convert a percentage (0-100) to a byte value (0-255).
 * Used when sending brightness/intensity values to the backend.
 */
export function percentToByte255(percent0to100: number): number {
  const clamped = clampNumber(percent0to100, 0, 100);
  return Math.round((clamped / 100) * 255);
}

/**
 * Convert a byte value (0-255) to a percentage (0-100).
 * Used when displaying brightness/intensity values from the backend.
 */
export function byte255ToPercent(byte0to255: number): number {
  const clamped = clampNumber(byte0to255, 0, 255);
  return Math.round((clamped / 255) * 100);
}
